/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { checkoutsCreate } from "../../funcs/checkoutsCreate.js";
import * as components from "../../models/components/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: components.CreateCheckoutRequest$inboundSchema,
};

export const tool$checkoutsCreate: ToolDefinition<typeof args> = {
  name: "checkouts-create",
  description: `Creates a new checkout session.

Create a new checkout session to accept one-time payments or start subscriptions. Returns a checkout URL to redirect customers.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await checkoutsCreate(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
